<template>
  <view
    class="date-container"
    wx:class="{{ {'space-between':!fuzzy} }}"
  >
    <block wx:if="{{fuzzy}}">
      <image
        class="time-icon"
        mode="widthFix"
        src="{{timeIcon}}"
      />
      <view bindtap="onDateTap" class="time-text">{{spTimeText}}</view>
    </block>
    <block wx:else>
      <view wx:for="{{times}}" wx:key="index" class="time" bindtap="onDateTap">
        <text class="t">{{item.t}}</text>
        <text class="w">{{item.w}}</text>
      </view>
      <view wx:if="{{type === 'range' && differ}}" class="differ">{{differ}}天</view>
    </block>
  </view>
</template>

<script>
  import { createComponent } from '@mpxjs/core'
  import dayjs from 'dayjs'
  import { formatDate, getFullDate, calcDateNum } from '@/utils/baseDate'
  const WEEKS = ['日', '一', '二', '三', '四', '五', '六']

  createComponent({
    properties: {
      type: {
        type: String,
        value: 'single' // single range mutiple
      },
      fromDate: {
        type: String,
        value: null
      },
      toDate: {
        type: String,
        value: null
      },
      fuzzy: {
        type: Boolean,
        value: false
      },
      fuzzyDate: {
        type: Object,
        value: null
      },
    },
    data: {
      timeIcon: 'https://ut-static.udache.com/webx/sfc/35rfzKgqxT8V2mqnUZPeb_clipboard_image_1700502082236.png',
    },
    computed: {
      spTimeText() {
        if(this.fuzzyDate) {
          const {
            weeks,
            months,
          } = this.fuzzyDate
          const weeksText = (weeks.length > 0 && weeks.length < 7)
            ? `周${weeks.map(i => WEEKS[i]).join(',')}`
            : ''
          const monthsText = months.map(i => dayjs(i).format('MM')).join(',')
          return `${monthsText}月  ${weeksText}`
        }
        const date = this.formatDate(this.fromDate)
        return `${date.t} ${date.w}`
      },
      times() {
        const _times = []

        _times.push({
          type: 'from',
          ...this.formatDate(this.fromDate),
        })

        if(this.type === 'range') {
          _times.push({
            type: 'to',
            ...this.formatDate(this.toDate),
          })
        }

        return _times
      },
      differ() {
        return calcDateNum(this.fromDate, this.toDate)
      }
    },
    methods: {
      formatDate(date = new Date()) {
        return {
          date,
          t: formatDate(date, 'MM月dd日'),
          w: `周${getFullDate(date).weekName}`
        }
      },
      onDateTap() {
        this.triggerEvent('dateTap')
      }
    }
  })
</script>

<style lang='stylus' scoped>
.date-container
  height 54px
  box-sizing border-box
  @extend .flex-center
  position relative
  font-family 'PingFang SC'
  .time-icon
    width 15px
    margin-right 13px
    flex none
  .time-text
    font-family 'PingFang SC'
    font-weight 500
    color #333
    font-size 18px
    flex 1
    overflow hidden
    text-overflow ellipsis
    white-space nowrap
  &.space-between
    justify-content space-between
    border-bottom 0.5px solid #EEEEEE
  .differ
    position absolute
    left 50%
    top 50%
    transform translate(-50%, -50%)
    color #666
    font-size 13px
  .time
    font-size 18px
    color #333
    font-weight 500
    flex-grow 1
    text-align right
    &:first-child
      text-align left
    .w
      font-size 13px
      margin-left 4px
      font-weight 400
</style>

<script name='json'>
  module.exports = {
    usingComponents: {
    }
  }
</script>
